export enum TipoPagamento {
  Externo = 0,
  AtendenteSTRM = 1,
}
